import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import Text from "./text/Text";
import CloseIcon from "@mui/icons-material/Close";
import { assets, clearAll, dates, type } from "./messages";
import { filterDataFrom } from "./constants";

function SelectedFilters({ handleRemoveFilter, handleClearAll }) {
  const transactionFilterData = useSelector(
    (state) => state.common.transactionFilterData
  );

  const displayFilterLabel = (key) => {
    if (key === "type") {
      return type;
    } else if (key === "target_currency") {
      return assets;
    } else if (key === "created") {
      return dates;
    }
  };

  return (
    <>
      <Box className="applied-filter-box">
        <Box className="selected-filters">
          {Object.entries(transactionFilterData).map(([key, value]) => {
            return (
              filterDataFrom.includes(key) && (
                <Box className="applied-filters">
                  <Text
                    className="default-text"
                    size="14"
                    font="regular"
                    sx={{ textTransform: "capitalize" }}
                  >
                    {displayFilterLabel(key)}
                  </Text>
                  <CloseIcon
                    sx={{
                      color: "#848B9E",
                      height: "16px",
                      width: "16px",
                      marginLeft: "8px",
                    }}
                    onClick={() => handleRemoveFilter(key)}
                  />
                </Box>
              )
            );
          })}
        </Box>
        {Object.keys(transactionFilterData).some((data) =>
          filterDataFrom.includes(data)
        ) && (
          <Text
            size="14"
            font="semibold"
            sx={{ color: "#2A67FF", cursor: "pointer", padding: "5px 0" }}
            onClick={handleClearAll}
          >
            {clearAll}
          </Text>
        )}
      </Box>
    </>
  );
}

export default SelectedFilters;
